const TTL_MS = 24 * 60 * 60 * 1000

function key(reportId) {
  return `locationSwitchJob_${reportId}`
}

export function writeJob(reportId, manifest) {
  try {
    localStorage.setItem(key(reportId), JSON.stringify(manifest))
  } catch (err) {
    console.error('[LocationSwitch] failed to write job to localStorage:', err)
  }
}

export function readJob(reportId) {
  const raw = localStorage.getItem(key(reportId))
  if (!raw) return null
  try {
    const manifest = JSON.parse(raw)
    if (Date.now() - new Date(manifest.startedAt).getTime() > TTL_MS) {
      clearJob(reportId)
      return null
    }
    return manifest
  } catch {
    clearJob(reportId)
    return null
  }
}

export function updateJobField(reportId, field, value) {
  const manifest = readJob(reportId)
  if (!manifest) return
  manifest[field] = value
  writeJob(reportId, manifest)
}

export function updateOperationStatus(reportId, shiftItemId, status) {
  const manifest = readJob(reportId)
  if (!manifest) return
  const op = manifest.operations.find((o) => o.shiftItemId === shiftItemId)
  if (op) op.status = status
  writeJob(reportId, manifest)
}

export function clearJob(reportId) {
  try {
    localStorage.removeItem(key(reportId))
  } catch (err) {
    console.error('[LocationSwitch] failed to clear job from localStorage:', err)
  }
}
